import { render, staticRenderFns } from "./SettingsListItem.vue?vue&type=template&id=66d3aa05&scoped=true"
import script from "./SettingsListItem.vue?vue&type=script&lang=js"
export * from "./SettingsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d3aa05",
  null
  
)

export default component.exports